import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import CatalogPage from "./pages/CatalogPage";
import DefaultPage from "./pages/DefaultPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* Dynamic Route: Matches /{organization}/{team}/{form} */}
        <Route path="/:organization/:team/:form" element={<CatalogPage />} />

        {/* Catch-All Route: Redirects everything else */}
        <Route path="*" element={<DefaultPage />} />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);
